import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { CitadelConfigurationService } from '@citadel/core';
import { take } from 'rxjs';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeComponent implements OnInit {
  private config = inject(CitadelConfigurationService);

  ngOnInit(): void {
    this.navigateToApp();
    //  window.location.href = 'sign-in';
  }
  private navigateToApp() {
    this.config.getGlobalSettingsLoaded().pipe(take(1)).subscribe(settings => {
      // BUG (found adopting strict mode, not fixed here): IAppSettings.rerouteAddress is declared
      // `string`, not a per-hostname map, so this index access can never resolve a real value at
      // runtime as written - see the identical site in app.component.ts.
      const rerouteAddress = (settings.rerouteAddress as unknown as Record<string, string> | undefined)?.[window.location.hostname];
      if (!!rerouteAddress) {
        window.location.href = rerouteAddress;
      } else {
        // This can only be used once the auth service runs under the main application
        //this.router.navigate(['..'], { relativeTo: this.route });
      }
    });
  }

}
